import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "../api";
import { useAuth } from "../AuthContext";
import { Page, Logo } from "../components/Layout";
import { ShieldCheck } from "lucide-react";

const inp = "w-full border border-gray-200 rounded-xl px-4 py-3 mt-1 focus:border-violet-500 outline-none";

export default function ImpostaPassword() {
  const { user, refresh, logout } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 8) return toast.error("La nuova password deve avere almeno 8 caratteri");
    if (f.new_password !== f.confirm) return toast.error("Le password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password impostata con successo");
      await refresh();
      nav(user?.role === "admin" ? "/admin" : "/profilo");
    } catch (er) { toast.error(apiErr(er)); }
    finally { setBusy(false); }
  };

  return (
    <Page>
      <div className="text-center pt-8 mb-4"><Logo className="inline-block" sub /></div>
      <div className="card p-6">
        <div className="flex items-center gap-2 mb-2"><ShieldCheck size={20} color="#7C1FD6" /><h1 className="serif text-2xl">Imposta nuova password</h1></div>
        <p className="text-sm text-gray-500 mb-4">Per motivi di sicurezza devi impostare una nuova password personale prima di continuare.</p>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="force-current" type="password" required placeholder="Password temporanea attuale" className={inp} value={f.current_password} onChange={set("current_password")} />
          <input data-testid="force-new" type="password" required minLength={8} placeholder="Nuova password (min 8 caratteri)" className={inp} value={f.new_password} onChange={set("new_password")} />
          <input data-testid="force-confirm" type="password" required placeholder="Conferma nuova password" className={inp} value={f.confirm} onChange={set("confirm")} />
          <button data-testid="force-submit" disabled={busy} className="btn-primary w-full">{busy ? "Attendere…" : "Imposta password e continua"}</button>
        </form>
      </div>
      <button data-testid="force-logout" onClick={async () => { await logout(); nav("/"); }} className="mt-6 text-sm text-gray-500 mx-auto block">Esci</button>
    </Page>
  );
}
